import { API_ENDPOINT } from "@/constants/appConstants";
import { PROFILE_PERFORMANCE_SEARCH_APPEARANCES_QUERY_KEY } from "@/lib/queryKeys";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { SearchAppearancesResponse, TimePeriod } from "../types";

export const getSearchAppearances = async <T>(
  timePeriod: TimePeriod = "90",
): Promise<T | Error> => {
  try {
    if (typeof window === "undefined") {
      throw new Error("Window is not available");
    }

    const response = await fetch(
      `${API_ENDPOINT(window.location.host).middleware.searchAppearances}?timePeriod=${timePeriod}`,
      {
        method: "GET",
        credentials: "include",
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: T = await response.json();
    return data;
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    } else {
      throw new Error(
        `Error occurred while fetching search appearances data, ${JSON.stringify(error)}`,
      );
    }
  }
};

export const useSearchAppearances = (
  timePeriod: TimePeriod = "90",
): UseQueryResult<SearchAppearancesResponse | Error> => {
  return useQuery({
    queryKey: [PROFILE_PERFORMANCE_SEARCH_APPEARANCES_QUERY_KEY, timePeriod],
    queryFn: () => getSearchAppearances<SearchAppearancesResponse>(timePeriod),
    retry: 1,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
